<fgb-banner [title]="'rewards.page.title' | translate"></fgb-banner>

<div class="d-block d-lg-none">
  <fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/'"></fgb-page-header>
</div>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container mt-4">
  <fgbcl-auction-list [defaultSort]="1"></fgbcl-auction-list>
</div>
